var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyingGlassBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "magnifying-glass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---search",
    transform: "translate(-1116.000000, -59.000000)",
    fill: "#006EFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(624.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass",
    transform: "translate(492.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5039362,13.3857045 C18.2117443,9.56204135 17.3061228,4.26738994 13.4824595,1.56022864 C9.65879623,-1.14693266 4.36414499,-0.241958184 1.65698369,3.58235194 C-1.05017761,7.40601523 -0.145202968,12.7000196 3.67910716,15.4071809 C6.40826204,17.3393891 10.0165168,17.4881698 12.8950993,15.788189 L19.1497093,22.0052803 C19.8250443,22.7161932 20.9486618,22.7446556 21.6595745,22.0693207 C22.3704874,21.3946327 22.3989498,20.2710152 21.724262,19.5601025 C21.702915,19.5374619 21.6822151,19.516762 21.6595745,19.495415 L15.5039362,13.3857045 Z M8.57528494,13.9653023 C5.55374353,13.9659492 3.10403739,11.5181837 3.10209661,8.49664232 C3.1014499,5.47510091 5.54921538,3.02539477 8.57140363,3.0241006 C11.5890637,3.02280728 14.0374762,5.46669161 14.0433062,8.4843517 C14.048473,11.5065399 11.6020013,13.9601272 8.5791661,13.9653023 C8.57787243,13.9653023 8.57722544,13.9653023 8.57528494,13.9653023 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassBlue);
export default __webpack_public_path__ + "static/media/magnifying-glass-blue.e9cbab1929472a471190d97d9d87f062.svg";
export { ForwardRef as ReactComponent };